import { render, staticRenderFns } from "./SupplierReturnMatrixTable.vue?vue&type=template&id=0c7a7547&scoped=true&"
import script from "./SupplierReturnMatrixTable.vue?vue&type=script&lang=js&"
export * from "./SupplierReturnMatrixTable.vue?vue&type=script&lang=js&"
import style0 from "./SupplierReturnMatrixTable.vue?vue&type=style&index=0&id=0c7a7547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a7547",
  null
  
)

export default component.exports